export interface ArticleSection {
  h: string;
  p1?: string;
  p2?: string;
  items?: string[];
}

export interface ArticleContent {
  metaTitle: string;
  metaDescription: string;
  h1: string;
  subtitle: string;
  quickAnswer: string;
  intro1: string;
  intro2: string;
  sections: ArticleSection[];
  takeawaysTitle: string;
  takeaways: string[];
  faq: { q: string; a: string }[];
  categoryLabel: string;
  readTime: string;
  author: string;
}

export interface ArticleMeta {
  slug: string;
  image: string;
}

export const articles: ArticleMeta[] = [
  {
    slug: "what-is",
    image:
      "https://readdy.ai/api/search-image?query=a%20minimalist%20overhead%20flat%20lay%20of%20a%20printed%20research%20spreadsheet%20a%20laptop%20and%20a%20few%20folded%20clothing%20items%20arranged%20on%20a%20warm%20cream%20wooden%20desk%20soft%20natural%20light%20organized%20research%20workspace%20editorial%20photography%20warm%20neutral%20tones%20clean%20composition&width=800&height=500&seq=art-what-is-01&orientation=landscape",
  },
  {
    slug: "how-it-works",
    image:
      "https://readdy.ai/api/search-image?query=neatly%20arranged%20rows%20of%20folded%20premium%20clothing%20items%20in%20earthy%20tones%20on%20a%20warm%20beige%20surface%20viewed%20from%20above%20soft%20studio%20light%20organized%20editorial%20flat%20lay%20warm%20neutral%20palette%20high%20detail%20clean%20grid%20composition&width=800&height=500&seq=art-how-it-works-01&orientation=landscape",
  },
  {
    slug: "how-to-read",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20hands%20comparing%20two%20folded%20garment%20items%20side%20by%20side%20on%20a%20warm%20wooden%20table%20soft%20natural%20window%20light%20editorial%20photography%20warm%20neutral%20tones%20high%20detail%20shallow%20depth%20of%20field%20clean%20composition&width=800&height=500&seq=art-how-to-read-01&orientation=landscape",
  },
  {
    slug: "how-to-find",
    image:
      "https://readdy.ai/api/search-image?query=a%20person%20browsing%20a%20product%20catalog%20on%20a%20smartphone%20resting%20on%20a%20warm%20cream%20desk%20with%20a%20notebook%20and%20coffee%20soft%20morning%20light%20cozy%20editorial%20photography%20warm%20neutral%20tones%20clean%20lifestyle%20composition&width=800&height=500&seq=art-how-to-find-01&orientation=landscape",
  },
  {
    slug: "usfans-review",
    image:
      "https://readdy.ai/api/search-image?query=a%20premium%20leather%20sneaker%20and%20folded%20tee%20arranged%20with%20five%20small%20wooden%20star%20shapes%20on%20a%20warm%20cream%20background%20soft%20studio%20light%20editorial%20review%20concept%20photography%20warm%20neutral%20tones%20high%20detail%20clean%20minimal%20composition&width=800&height=500&seq=art-review-01&orientation=landscape",
  },
  {
    slug: "shipping-cost",
    image:
      "https://readdy.ai/api/search-image?query=a%20cardboard%20shipping%20box%20with%20neatly%20folded%20clothing%20items%20and%20kraft%20paper%20beside%20it%20on%20a%20warm%20beige%20surface%20soft%20natural%20light%20editorial%20logistics%20photography%20warm%20neutral%20tones%20high%20detail%20clean%20composition&width=800&height=500&seq=art-shipping-01&orientation=landscape",
  },
  {
    slug: "coupon",
    image:
      "https://readdy.ai/api/search-image?query=a%20folded%20garment%20with%20a%20small%20kraft%20paper%20discount%20tag%20tied%20with%20twine%20on%20a%20warm%20cream%20background%20soft%20studio%20light%20editorial%20promotion%20concept%20photography%20warm%20neutral%20tones%20high%20detail%20clean%20minimal%20composition&width=800&height=500&seq=art-coupon-01&orientation=landscape",
  },
  {
    slug: "discount-code",
    image:
      "https://readdy.ai/api/search-image?query=a%20premium%20accessory%20flat%20lay%20with%20small%20round%20price%20tags%20and%20a%20folded%20shirt%20on%20a%20warm%20beige%20surface%20soft%20natural%20light%20editorial%20shopping%20concept%20photography%20warm%20neutral%20tones%20high%20detail%20clean%20composition&width=800&height=500&seq=art-discount-01&orientation=landscape",
  },
  {
    slug: "warehouse",
    image:
      "https://readdy.ai/api/search-image?query=stacked%20organized%20cardboard%20boxes%20and%20folded%20apparel%20on%20warm%20wooden%20warehouse%20shelves%20soft%20directional%20light%20editorial%20storage%20concept%20photography%20warm%20earthy%20tones%20high%20detail%20clean%20composition&width=800&height=500&seq=art-warehouse-01&orientation=landscape",
  },
  {
    slug: "safety-guide",
    image:
      "https://readdy.ai/api/search-image?query=a%20folded%20premium%20garment%20with%20a%20small%20brass%20padlock%20and%20key%20resting%20beside%20it%20on%20a%20warm%20cream%20surface%20soft%20studio%20light%20editorial%20safety%20concept%20photography%20warm%20neutral%20tones%20high%20detail%20clean%20minimal%20composition&width=800&height=500&seq=art-safety-01&orientation=landscape",
  },
];

export const BUYING_GUIDE_IMAGE =
  "https://readdy.ai/api/search-image?query=a%20warm%20inviting%20scene%20of%20a%20kraft%20paper%20shopping%20bag%20with%20neatly%20folded%20clothing%20items%20beside%20it%20on%20a%20light%20wooden%20table%20soft%20golden%20hour%20light%20premium%20retail%20editorial%20photography%20warm%20neutral%20tones%20cozy%20welcoming%20mood%20clean%20minimal%20composition&width=1600&height=900&seq=buying-guide-hero-01&orientation=landscape";